import { render } from "./AccountHelp.vue?vue&type=template&id=7e71c7df&scoped=true"
import script from "./AccountHelp.vue?vue&type=script&lang=js"
export * from "./AccountHelp.vue?vue&type=script&lang=js"

import "./AccountHelp.vue?vue&type=style&index=0&id=7e71c7df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e71c7df"]])

export default __exports__